'use client';

import { c as _c } from "react/compiler-runtime";
import { Grid, Icon, type IconNames, TextField, TextPassage } from '@petsmart-ui/sparky';
import { useFormikContext } from 'formik';
import { type AccountPaymentsSuccessResponse, getCreditCardIcon } from '@libs/common-next';
import type { PaymentFormInterface } from './types';
import { handleSetExpirationDate } from './utils';
export function CardDetailsInputs(t0) {
  const $ = _c(27);
  const {
    cardData
  } = t0;
  const {
    values,
    touched,
    errors,
    handleChange,
    handleBlur,
    setFieldValue
  } = useFormikContext();
  const {
    cardType,
    lastFour
  } = cardData;
  let t1;
  if ($[0] !== cardType) {
    t1 = getCreditCardIcon(cardType);
    $[0] = cardType;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const cardIcon = t1 as IconNames;
  let t2;
  if ($[2] !== cardIcon) {
    t2 = <Icon name={cardIcon} size="3xl" data-testid="card-icon" />;
    $[2] = cardIcon;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = `${cardType} ••••${lastFour}`;
  let t4;
  if ($[4] !== t3) {
    t4 = <TextPassage><span className="card-name" data-testid="card-name">{t3}</span></TextPassage>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t4) {
    t5 = <Grid.Item><div className="payment-form__edit-form--card-info" data-testid="edit-payment-form-card-info" data-cs-mask={true}>{t2}{t4}</div></Grid.Item>;
    $[6] = t2;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== setFieldValue) {
    t6 = e => {
      handleSetExpirationDate(e, setFieldValue);
    };
    $[9] = setFieldValue;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = touched.expirationDate && !!errors.expirationDate;
  const t8 = touched.expirationDate && errors?.expirationDate?.[0];
  let t9;
  if ($[11] !== handleBlur || $[12] !== t6 || $[13] !== t7 || $[14] !== t8 || $[15] !== values.expirationDate) {
    t9 = <Grid.Item><TextField data-cs-mask={true} data-testid="expiration-date" id="expirationDate" label="Exp MM/YY" name="expirationDate" maxLength={5} type="text" value={values.expirationDate} required={true} onChange={t6} onBlur={handleBlur} isError={t7} fieldNote={t8} /></Grid.Item>;
    $[11] = handleBlur;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
    $[15] = values.expirationDate;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const t10 = touched.nameOnCard && !!errors.nameOnCard;
  const t11 = touched.nameOnCard && errors?.nameOnCard?.[0];
  let t12;
  if ($[17] !== handleBlur || $[18] !== handleChange || $[19] !== t10 || $[20] !== t11 || $[21] !== values.nameOnCard) {
    t12 = <Grid.Item><TextField data-cs-mask={true} data-testid="name-on-card" id="nameOnCard" label="Name on card" name="nameOnCard" type="text" value={values.nameOnCard} onChange={handleChange} onBlur={handleBlur} required={true} isError={t10} fieldNote={t11} maxLength={30} /></Grid.Item>;
    $[17] = handleBlur;
    $[18] = handleChange;
    $[19] = t10;
    $[20] = t11;
    $[21] = values.nameOnCard;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t12 || $[24] !== t5 || $[25] !== t9) {
    t13 = <Grid gap="sm" className="payment-form__edit-form sparky-u-margin-bottom-sm" data-testid="edit-payment-form">{t5}{t9}{t12}</Grid>;
    $[23] = t12;
    $[24] = t5;
    $[25] = t9;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  return t13;
}